import Api from '../Api';

import { url } from './config';
import { Meal } from './types';

class ExtendedApi extends Api<Meal> {}

const api = new ExtendedApi(url);

export default api;
